/* app/events.js
Bento Box App Event Bus Module
*/

import Backbone from 'backbone';
import _ from 'underscore';


export default _.extend({}, Backbone.Events);
